/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-09-08T12:05:06+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-09-22T11:20:45+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ATextInputDescription from 'common/inputs/components/ATextInputDescription';
import AButtonIconHelp from 'common/buttons/components/AButtonIconHelp';
import ALegendMain from './ALegendMain';


/**
 * MFieldsetCheckout - …
**/
class MFieldsetCheckout extends Component {
  renderToolButton() {
    const {
      toolLabel,
      toolIcon,
      onPressTool,
      showTooltip,
      helpId,
    } = this.props;
    return (
      <AButtonIconHelp
        label={toolLabel}
        icon={toolIcon}
        onPress={onPressTool}
        showTooltip={showTooltip}
        helpId={helpId}
      />
    );
  }

  render() {
    const {
      legend,
      description,
      toolLabel,
      toolIcon,
      onPressTool,
      children,
      ...other
    } = this.props;

    const legendEl = (legend) ?
            <ALegendMain dangerouslySetInnerHTML={{__html: legend}}></ALegendMain> : null;

    const horizontalLine = (!legend) ? null
            : (<hr className="m-fieldset-checkout__line"/>);

    const toolButtonEl = (toolLabel || toolIcon || onPressTool) ? this.renderToolButton() : null;

    const descriptionEl = (!description) ? null
            : (<ATextInputDescription>{description}</ATextInputDescription>);


    return (
      <fieldset {...other} className="m-fieldset m-fieldset-checkout">
        <div className="m-fieldset-checkout__header">
          {legendEl}
          {horizontalLine}
          {toolButtonEl}
        </div>
        {descriptionEl}
        <div className="m-fieldset-checkout__children">
          {children}
        </div>
      </fieldset>
    );
  }
}


MFieldsetCheckout.propTypes = {
  children: PropTypes.any,
  /**
     * legend to be displayed as
     */
  legend: PropTypes.string,
  /**
     * description for the input
     */
  description: PropTypes.any,
  /**
     * label for the tool-button, like 'Help'
     */
  toolLabel: PropTypes.string,
  /**
     * icon for the tool button like 'question-sign'
     */
  toolIcon: PropTypes.string,
  /**
     * displays a tool button with icon and fires
     * whe it is pressed. useful to show extra help infos
     */
  onPressTool: PropTypes.func,
  showTooltip: PropTypes.bool,
  helpId: PropTypes.string,
};
MFieldsetCheckout.defaultProps = {};
export default MFieldsetCheckout;

